import { ref, onMounted, nextTick } from 'vue-demi';

export function useHeaderHorizScroll({ horizontalTabRef }) {
    const shouldScroll = ref(true);

    const scrollNavToHorizontalCenter = () => {
        nextTick(() => {
            const parent = horizontalTabRef.value.querySelector('.horizontal-tab-header-real');
            const child = parent.querySelector('.horizontal-tab-part.active');
            const parentRect = parent.getBoundingClientRect();
            const childRect = child.getBoundingClientRect();
            const scrollLeft = child.offsetLeft + childRect.width / 2 - parentRect.width / 2;
            parent.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        });
    };

    onMounted(() => {
        nextTick(() => {
            const horizontalTabHeader = horizontalTabRef.value?.querySelector('.horizontal-tab-header-real');
            const isScrollable =
                horizontalTabHeader && horizontalTabHeader.scrollWidth > horizontalTabHeader.offsetWidth;
            shouldScroll.value = isScrollable;
        });
    });

    return {
        shouldScroll,
        scrollNavToHorizontalCenter
    };
}
